import { useState } from "react";

/**
 * Hook to manage tool call expansion state
 */
export function useToolCallExpansion() {
  const [expandedToolCalls, setExpandedToolCalls] = useState<Set<string>>(
    new Set(),
  );

  const toggleToolCallExpansion = (partId: string) => {
    setExpandedToolCalls((prev) => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(partId)) {
        newExpanded.delete(partId);
      } else {
        newExpanded.add(partId);
      }
      return newExpanded;
    });
  };

  return {
    expandedToolCalls,
    toggleToolCallExpansion,
  };
}
